/**
 * @generated SignedSource<<910dbbb23909d0bd10217f97f8c702f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_user" | "PdpSharedDescriptionAdditionalOptions_user">;
  readonly " $fragmentType": "PdpRespAboutItemPanel_user";
};
export type PdpRespAboutItemPanel_user$key = {
  readonly " $data"?: PdpRespAboutItemPanel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptions_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4e45456f6bb2ed17c87a7f13e57d8da5";

export default node;
